<!-- @/layout/index.vue -->
<template>
    <div class="layout-container" ref="fullscreenTarget">
        <!-- 移动端导航 -->
        <MobileNav :isOpen="isMobileMenuOpen" @close="isMobileMenuOpen = false" />
        
        <!-- 顶部导航栏 -->
        <header class="main-header">
            <div class="header-container">
                <!-- 移动端汉堡菜单按钮 -->
                <div class="mobile-menu-btn" @click="toggleMobileMenu">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                
                <div class="logo" @click="jumpHome">
                    <img src="@/assets/image/logo.png" alt="">
                    <span>伴学霸火</span>
                </div>

                <!-- 导航菜单 -->
                <nav class="main-nav desktop-only">
                    <el-menu mode="horizontal" :default-active="currentRoute" :ellipsis="false" class="nav-menu">
                        <el-menu-item :class="{
                            'active-bg': currentRoute === 'dashboard'
                        }" index="dashboard" @click="navigate('dashboard')">
                            <svg v-if="currentRoute === 'dashboard'" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8 16.9997H16M11.0177 2.76375L4.23539 8.03888C3.78202 8.3915 3.55534 8.56781 3.39203 8.78861C3.24737 8.9842 3.1396 9.20454 3.07403 9.43881C3 9.70327 3 9.99045 3 10.5648V17.7997C3 18.9198 3 19.4799 3.21799 19.9077C3.40973 20.284 3.71569 20.59 4.09202 20.7818C4.51984 20.9997 5.07989 20.9997 6.2 20.9997H17.8C18.9201 20.9997 19.4802 20.9997 19.908 20.7818C20.2843 20.59 20.5903 20.284 20.782 19.9077C21 19.4799 21 18.9198 21 17.7997V10.5648C21 9.99045 21 9.70327 20.926 9.43881C20.8604 9.20454 20.7526 8.9842 20.608 8.78861C20.4447 8.56781 20.218 8.3915 19.7646 8.03888L12.9823 2.76376C12.631 2.4905 12.4553 2.35388 12.2613 2.30136C12.0902 2.25502 11.9098 2.25502 11.7387 2.30136C11.5447 2.35388 11.369 2.4905 11.0177 2.76375Z"
                                    stroke="#00D47E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4 9.5L12 3L20 9.5V19.5H4V9.5Z" fill="#00D47E" stroke="#00D47E" />
                                <rect x="6" y="15" width="12" height="3" rx="1.5" fill="#F4F6F8" />
                            </svg>
                            <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8 16.9997H16M11.0177 2.76375L4.23539 8.03888C3.78202 8.3915 3.55534 8.56781 3.39203 8.78861C3.24737 8.9842 3.1396 9.20454 3.07403 9.43881C3 9.70327 3 9.99045 3 10.5648V17.7997C3 18.9198 3 19.4799 3.21799 19.9077C3.40973 20.284 3.71569 20.59 4.09202 20.7818C4.51984 20.9997 5.07989 20.9997 6.2 20.9997H17.8C18.9201 20.9997 19.4802 20.9997 19.908 20.7818C20.2843 20.59 20.5903 20.284 20.782 19.9077C21 19.4799 21 18.9198 21 17.7997V10.5648C21 9.99045 21 9.70327 20.926 9.43881C20.8604 9.20454 20.7526 8.9842 20.608 8.78861C20.4447 8.56781 20.218 8.3915 19.7646 8.03888L12.9823 2.76376C12.631 2.4905 12.4553 2.35388 12.2613 2.30136C12.0902 2.25502 11.9098 2.25502 11.7387 2.30136C11.5447 2.35388 11.369 2.4905 11.0177 2.76375Z"
                                    stroke="#6A7077" stroke-width="1.7" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                            <span>首页</span>
                        </el-menu-item>
                        <el-menu-item :class="{
                            'active-bg': currentRoute === 'course-sales'
                        }" index="course-sales" @click="navigate('course-sales')">
                            <svg v-if="currentRoute === 'course-sales'" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.4789 22.4998H4.51643C2.89924 22.4998 1.57971 21.2201 1.57971 19.6475V5.89434C1.57971 4.32168 2.8969 3.04199 4.51643 3.04199H7.7719V4.66621H4.51643C3.79221 4.66621 3.20393 5.21934 3.20393 5.89434V19.6475C3.20393 20.3248 3.79456 20.8756 4.51643 20.8756H19.4789C20.2031 20.8756 20.7914 20.3225 20.7914 19.6475V5.89434C20.7914 5.21699 20.2008 4.66621 19.4789 4.66621H16.2281V3.04199H19.4836C21.1008 3.04199 22.4203 4.32168 22.4203 5.89434V19.6475C22.418 21.2201 21.1008 22.4998 19.4789 22.4998Z"
                                    fill="#00D47E" />
                                <path
                                    d="M8 5L7 4H3L2.5 6V13.5L2 20L4 22H11.5H20L21.5 19.5L22 8.5L20.5 4H17.5L16 5.5L8 5Z"
                                    fill="#00D47E" />
                                <path
                                    d="M17.7187 10.448L14.025 14.559L12.5344 13.0074C12.2484 12.7098 11.7844 12.7098 11.4984 13.0074C11.2125 13.3051 11.2125 13.7902 11.4984 14.0879L13.5094 16.1762C13.6523 16.3262 13.8398 16.4012 14.0273 16.4012C14.1304 16.4012 14.2265 16.373 14.325 16.3285C14.4328 16.291 14.5336 16.2301 14.6156 16.1387L18.7945 11.491C19.0617 11.1746 19.0336 10.6895 18.7265 10.4105C18.4336 10.148 17.9953 10.1645 17.7187 10.448ZM11.1984 11.8426H5.88748C5.43982 11.8426 5.07654 11.477 5.07654 11.0316C5.07654 10.5863 5.44216 10.2207 5.88748 10.2207H11.2008C11.6484 10.2207 12.0117 10.5863 12.0117 11.0316C12.0117 11.477 11.6461 11.8426 11.1984 11.8426ZM8.65544 16.4316H5.88748C5.43982 16.4316 5.07654 16.066 5.07654 15.6207C5.07654 15.173 5.44216 14.8098 5.88748 14.8098H8.65544C9.1031 14.8098 9.46638 15.1754 9.46638 15.6207C9.46638 16.066 9.10076 16.4316 8.65544 16.4316Z"
                                    fill="#F4F6F8" />
                                <path
                                    d="M8.7113 2H15.2885C16.3246 2.00011 17.1691 2.84475 17.1693 3.88086C17.1693 4.91715 16.3247 5.76259 15.2885 5.7627H8.7113C7.67512 5.76248 6.83044 4.91709 6.83044 3.88086C6.83066 2.84481 7.67525 2.00021 8.7113 2Z"
                                    fill="#F4F6F8" stroke="#00D47E" />
                            </svg>
                            <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M17.7187 10.4484L14.025 14.5594L12.5344 13.0078C12.2484 12.7102 11.7844 12.7102 11.4984 13.0078C11.2125 13.3055 11.2125 13.7906 11.4984 14.0883L13.5094 16.1766C13.6523 16.3266 13.8398 16.4016 14.0273 16.4016C14.1304 16.4016 14.2265 16.3734 14.325 16.3289C14.4328 16.2914 14.5336 16.2305 14.6156 16.1391L18.7945 11.4914C19.0617 11.175 19.0336 10.6898 18.7265 10.4109C18.4336 10.1484 17.9953 10.1648 17.7187 10.4484ZM15.2883 6.2625H8.71169C7.39919 6.2625 6.33044 5.19375 6.33044 3.88125C6.33044 2.56875 7.39919 1.5 8.71169 1.5H15.2883C16.6008 1.5 17.6695 2.56875 17.6695 3.88125C17.6695 5.19375 16.6008 6.2625 15.2883 6.2625ZM8.70935 3.12422C8.29216 3.12422 7.95232 3.46406 7.95232 3.88125C7.95232 4.29844 8.29216 4.63828 8.70935 4.63828H15.2859C15.7031 4.63828 16.0429 4.29844 16.0429 3.88125C16.0429 3.46406 15.7031 3.12422 15.2859 3.12422H8.70935ZM11.1984 11.843H5.88748C5.43982 11.843 5.07654 11.4773 5.07654 11.032C5.07654 10.5867 5.44216 10.2211 5.88748 10.2211H11.2008C11.6484 10.2211 12.0117 10.5867 12.0117 11.032C12.0117 11.4773 11.6461 11.843 11.1984 11.843ZM8.65544 16.432H5.88748C5.43982 16.432 5.07654 16.0664 5.07654 15.6211C5.07654 15.1734 5.44216 14.8102 5.88748 14.8102H8.65544C9.1031 14.8102 9.46638 15.1758 9.46638 15.6211C9.46638 16.0664 9.10076 16.432 8.65544 16.432Z"
                                    fill="#6A7077" />
                                <path
                                    d="M19.4789 22.4998H4.51643C2.89924 22.4998 1.57971 21.2201 1.57971 19.6475V5.89434C1.57971 4.32168 2.8969 3.04199 4.51643 3.04199H7.7719V4.66621H4.51643C3.79221 4.66621 3.20393 5.21934 3.20393 5.89434V19.6475C3.20393 20.3248 3.79456 20.8756 4.51643 20.8756H19.4789C20.2031 20.8756 20.7914 20.3225 20.7914 19.6475V5.89434C20.7914 5.21699 20.2008 4.66621 19.4789 4.66621H16.2281V3.04199H19.4836C21.1008 3.04199 22.4203 4.32168 22.4203 5.89434V19.6475C22.418 21.2201 21.1008 22.4998 19.4789 22.4998Z"
                                    fill="#6A7077" />
                            </svg>
                            <span>销课中心</span>
                        </el-menu-item>
                        <el-menu-item :class="{
                            'active-bg': currentRoute === 'user-info'
                        }" index="user-info" @click="navigate('user-info')">
                            <svg v-if="currentRoute === 'user-info'" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.0168 14.6372C14.9091 13.5414 16.182 11.4903 16.182 9.13992C16.182 5.63756 13.3525 2.7969 9.86422 2.7969C6.37451 2.7969 3.54508 5.63616 3.54508 9.13992C3.54508 11.4931 4.82071 13.5456 6.7173 14.6414C3.74598 15.6403 1.44198 18.0131 0.766234 21.0069C0.683346 21.3722 0.912341 21.7361 1.2748 21.8175C1.63866 21.9004 2.00112 21.6714 2.0826 21.3076C2.84124 17.9457 6.07667 15.4829 9.87265 15.4829C13.6391 15.4829 16.8563 17.9078 17.6472 21.2331C17.7344 21.597 18.0968 21.9061 18.4593 21.8189C18.8217 21.7318 19.0451 21.2823 18.958 20.9184C18.257 17.9583 15.9642 15.622 13.0168 14.6372ZM22.709 21.5057C22.3466 21.5942 21.9827 21.368 21.897 21.0055C21.2634 18.3419 19.371 16.0646 16.7566 14.7932C16.4222 14.6302 16.2817 14.2256 16.4433 13.887C16.4798 13.8111 16.5304 13.7437 16.588 13.6889C16.6203 13.6299 16.6638 13.5765 16.7144 13.5274C17.924 12.374 18.6208 10.778 18.6208 9.06968C18.6208 6.628 17.1893 4.44763 15.0117 3.46141C14.6717 3.30828 14.5214 2.90648 14.6731 2.5651C14.8263 2.22371 15.2266 2.07198 15.5666 2.22652C18.2247 3.4305 19.9695 6.08993 19.9695 9.06968C19.9695 10.9101 19.305 12.6451 18.1333 13.9952C20.6958 15.4942 22.5461 17.8993 23.2092 20.6908C23.2963 21.0533 23.0729 21.4186 22.709 21.5057Z"
                                    fill="#00D47E" />
                                <path
                                    d="M4.89377 9.13992C4.89377 11.8949 7.11909 14.1286 9.86422 14.1286C12.608 14.1286 14.8333 11.8949 14.8333 9.13992M13.0168 14.6372C14.9091 13.5414 16.182 11.4903 16.182 9.13992C16.182 5.63756 13.3525 2.7969 9.86422 2.7969C6.37451 2.7969 3.54508 5.63616 3.54508 9.13992C3.54508 11.4931 4.82071 13.5456 6.7173 14.6414C3.74598 15.6403 1.44198 18.0131 0.766234 21.0069C0.683346 21.3722 0.912341 21.7361 1.2748 21.8175C1.63866 21.9004 2.00112 21.6714 2.0826 21.3076C2.84124 17.9457 6.07667 15.4829 9.87265 15.4829C13.6391 15.4829 16.8563 17.9078 17.6472 21.2331C17.7343 21.597 18.0968 21.9061 18.4593 21.8189C18.8217 21.7318 19.0451 21.2823 18.958 20.9184C18.257 17.9583 15.9642 15.622 13.0168 14.6372ZM22.709 21.5057C22.3466 21.5942 21.9827 21.368 21.897 21.0055C21.2634 18.3419 19.371 16.0646 16.7566 14.7932C16.4222 14.6302 16.2817 14.2256 16.4433 13.887C16.4798 13.8111 16.5304 13.7437 16.588 13.6889C16.6203 13.6299 16.6638 13.5765 16.7144 13.5274C17.924 12.374 18.6208 10.778 18.6208 9.06968C18.6208 6.628 17.1893 4.44763 15.0117 3.46141C14.6717 3.30828 14.5214 2.90648 14.6731 2.5651C14.8263 2.22371 15.2266 2.07198 15.5666 2.22652C18.2247 3.4305 19.9695 6.08993 19.9695 9.06968C19.9695 10.9101 19.305 12.6451 18.1333 13.9952C20.6958 15.4942 22.5461 17.8993 23.2092 20.6908C23.2963 21.0533 23.0729 21.4186 22.709 21.5057Z"
                                    stroke="#00D47E" stroke-width="0.3" />
                            </svg>
                            <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.0168 14.6372C14.9091 13.5414 16.182 11.4903 16.182 9.13992C16.182 5.63756 13.3525 2.7969 9.86422 2.7969C6.37451 2.7969 3.54508 5.63616 3.54508 9.13992C3.54508 11.4931 4.82071 13.5456 6.7173 14.6414C3.74598 15.6403 1.44198 18.0131 0.766234 21.0069C0.683346 21.3722 0.912341 21.7361 1.2748 21.8175C1.63866 21.9004 2.00112 21.6714 2.0826 21.3076C2.84124 17.9457 6.07667 15.4829 9.87265 15.4829C13.6391 15.4829 16.8563 17.9078 17.6472 21.2331C17.7344 21.597 18.0968 21.9061 18.4593 21.8189C18.8217 21.7318 19.0451 21.2823 18.958 20.9184C18.257 17.9583 15.9642 15.622 13.0168 14.6372ZM4.89377 9.13992C4.89377 6.38496 7.11909 4.1512 9.86422 4.1512C12.608 4.1512 14.8333 6.38496 14.8333 9.13992C14.8333 11.8949 12.608 14.1286 9.86422 14.1286C7.11909 14.1286 4.89377 11.8949 4.89377 9.13992ZM22.709 21.5057C22.3466 21.5942 21.9827 21.368 21.897 21.0055C21.2634 18.3419 19.371 16.0646 16.7566 14.7932C16.4222 14.6302 16.2817 14.2256 16.4433 13.887C16.4798 13.8111 16.5304 13.7437 16.588 13.6889C16.6203 13.6299 16.6638 13.5765 16.7144 13.5274C17.924 12.374 18.6208 10.778 18.6208 9.06968C18.6208 6.628 17.1893 4.44763 15.0117 3.46141C14.6717 3.30828 14.5214 2.90648 14.6731 2.5651C14.8263 2.22371 15.2266 2.07198 15.5666 2.22652C18.2247 3.4305 19.9695 6.08993 19.9695 9.06968C19.9695 10.9101 19.305 12.6451 18.1333 13.9952C20.6958 15.4942 22.5461 17.8993 23.2092 20.6908C23.2963 21.0533 23.0729 21.4186 22.709 21.5057Z"
                                    fill="#6A7077" stroke="#6A7077" stroke-width="0.3" />
                            </svg>
                            <span>用户信息</span>
                        </el-menu-item>
                        <el-menu-item :class="{
                            'active-bg': currentRoute === 'profile'
                        }" index="profile" @click="navigate('profile')">
                            <svg v-if="currentRoute === 'profile'" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15.4604 14.0608C17.5368 12.852 18.9334 10.5895 18.9334 7.99686C18.9334 4.13348 15.8288 1 12.0013 1C8.17223 1 5.06768 4.13193 5.06768 7.99686C5.06768 10.5926 6.46735 12.8567 8.54836 14.0655C5.28811 15.1673 2.76007 17.7847 2.01862 21.0871C1.92767 21.49 2.17893 21.8914 2.57663 21.9813C2.97588 22.0727 3.37358 21.8201 3.46299 21.4188C4.29539 17.7103 7.84544 14.9937 12.0105 14.9937C16.1433 14.9937 19.6733 17.6685 20.5411 21.3366C20.6367 21.738 21.0344 22.0789 21.4321 21.9828C21.8298 21.8868 22.0749 21.3909 21.9793 20.9895C21.2101 17.7243 18.6944 15.1471 15.4604 14.0608Z"
                                    fill="#00D47E" />
                                <path
                                    d="M6.54751 7.99686C6.54751 11.0358 8.98922 13.4998 12.0013 13.4998C15.0118 13.4998 17.4535 11.0358 17.4535 7.99686M15.4604 14.0608C17.5368 12.852 18.9334 10.5895 18.9334 7.99686C18.9334 4.13348 15.8288 1 12.0013 1C8.17223 1 5.06768 4.13193 5.06768 7.99686C5.06768 10.5926 6.46735 12.8567 8.54836 14.0655C5.28811 15.1673 2.76007 17.7847 2.01862 21.0871C1.92767 21.49 2.17893 21.8914 2.57663 21.9813C2.97588 22.0727 3.37358 21.8201 3.46299 21.4188C4.29539 17.7103 7.84544 14.9937 12.0105 14.9937C16.1433 14.9937 19.6733 17.6685 20.5411 21.3366C20.6367 21.738 21.0344 22.0789 21.4321 21.9828C21.8298 21.8868 22.0749 21.3909 21.9793 20.9895C21.2101 17.7243 18.6944 15.1471 15.4604 14.0608Z"
                                    stroke="#00D47E" stroke-width="0.3" />
                            </svg>
                            <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15.4604 14.0608C17.5368 12.852 18.9334 10.5895 18.9334 7.99686C18.9334 4.13348 15.8288 1 12.0013 1C8.17224 1 5.06768 4.13193 5.06768 7.99686C5.06768 10.5926 6.46735 12.8567 8.54836 14.0655C5.28811 15.1673 2.76007 17.7847 2.01862 21.0871C1.92767 21.49 2.17893 21.8914 2.57663 21.9813C2.97588 22.0727 3.37358 21.8201 3.46299 21.4188C4.29539 17.7103 7.84544 14.9937 12.0105 14.9937C16.1433 14.9937 19.6733 17.6685 20.5411 21.3366C20.6367 21.738 21.0344 22.0789 21.4321 21.9828C21.8298 21.8868 22.0749 21.3909 21.9793 20.9895C21.2101 17.7243 18.6944 15.1471 15.4604 14.0608ZM6.54751 7.99686C6.54751 4.95791 8.98922 2.4939 12.0013 2.4939C15.0118 2.4939 17.4535 4.95791 17.4535 7.99686C17.4535 11.0358 15.0118 13.4998 12.0013 13.4998C8.98922 13.4998 6.54751 11.0358 6.54751 7.99686Z"
                                    fill="#6A7077" stroke="#6A7077" stroke-width="0.3" />
                            </svg>
                            <span>个人中心</span>
                        </el-menu-item>
                    </el-menu>
                </nav>

                <!-- 右侧工具栏 -->
                <div class="header-tools desktop-only">
                    <!-- 全屏 -->
                    <div class="tool-icon" @click="toggleFullscreen">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2.74955 7.50358C2.74955 7.71083 2.58177 7.87861 2.37453 7.87861C2.16777 7.87861 2 7.71083 2 7.50358V4.37207C2 3.71922 2.26646 3.12608 2.69625 2.69627C3.12604 2.26647 3.71917 2 4.372 2H7.50341C7.71066 2 7.87843 2.16778 7.87843 2.37454C7.87843 2.58179 7.71066 2.74957 7.50341 2.74957H4.372C3.92592 2.74957 3.52031 2.93215 3.22621 3.22625C2.93212 3.52036 2.74955 3.92598 2.74955 4.37207V7.50358ZM12.4961 2.74957C12.2893 2.74957 12.1216 2.58179 12.1216 2.37454C12.1216 2.16778 12.2893 2 12.4961 2H15.628C16.2808 2 16.8735 2.26647 17.3033 2.69627C17.733 3.12608 18 3.71922 18 4.37207V7.50358C18 7.71083 17.8322 7.87861 17.625 7.87861C17.4182 7.87861 17.2505 7.71083 17.2505 7.50358V4.37207C17.2505 3.92598 17.0679 3.52036 16.7733 3.22625C16.4792 2.93215 16.0736 2.74957 15.628 2.74957H12.4961ZM17.2505 12.4964C17.2505 12.2897 17.4182 12.1219 17.625 12.1219C17.8322 12.1219 18 12.2897 18 12.4964V15.6284C18 16.2808 17.733 16.8739 17.3033 17.3037C16.8735 17.7335 16.2808 18 15.628 18H12.4961C12.2893 18 12.1216 17.8322 12.1216 17.6255C12.1216 17.4187 12.2893 17.2504 12.4961 17.2504H15.628C16.0736 17.2504 16.4792 17.0679 16.7733 16.7737C17.0679 16.4796 17.2505 16.074 17.2505 15.6284V12.4964ZM7.50341 17.2504C7.71066 17.2504 7.87843 17.4187 7.87843 17.6255C7.87843 17.8322 7.71066 18 7.50341 18H4.372C3.71917 18 3.12604 17.7335 2.69625 17.3037C2.26646 16.8739 2 16.2808 2 15.6284V12.4964C2 12.2897 2.16777 12.1219 2.37453 12.1219C2.58177 12.1219 2.74955 12.2897 2.74955 12.4964V15.6284C2.74955 16.074 2.93212 16.4796 3.22621 16.7737C3.52031 17.0679 3.92592 17.2504 4.372 17.2504H7.50341Z"
                                fill="#35374B" stroke="#35374B" stroke-width="0.5" />
                        </svg>
                    </div>
                    <div class="tool-icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.00004 1.66699H15C16.2657 1.66699 17.2917 2.69303 17.2917 3.95866V16.042C17.2917 17.3076 16.2657 18.3337 15 18.3337H5.00004C3.73442 18.3337 2.70837 17.3076 2.70837 16.042V3.95866C2.70837 2.69303 3.73442 1.66699 5.00004 1.66699ZM5.00004 2.91699C4.86325 2.91699 4.72779 2.94394 4.60141 2.99628C4.47503 3.04863 4.3602 3.12536 4.26347 3.22209C4.16674 3.31882 4.09001 3.43365 4.03767 3.56003C3.98532 3.68641 3.95837 3.82187 3.95837 3.95866V16.042C3.95837 16.1788 3.98532 16.3142 4.03767 16.4406C4.09001 16.567 4.16674 16.6818 4.26347 16.7786C4.3602 16.8753 4.47503 16.952 4.60141 17.0044C4.72779 17.0567 4.86325 17.0837 5.00004 17.0837H15C15.1368 17.0837 15.2723 17.0567 15.3987 17.0044C15.5251 16.952 15.6399 16.8753 15.7366 16.7786C15.8333 16.6818 15.9101 16.567 15.9624 16.4406C16.0148 16.3142 16.0417 16.1788 16.0417 16.042V3.95866C16.0417 3.82187 16.0148 3.68641 15.9624 3.56003C15.9101 3.43365 15.8333 3.31882 15.7366 3.22209C15.6399 3.12536 15.5251 3.04863 15.3987 2.99628C15.2723 2.94394 15.1368 2.91699 15 2.91699H5.00004ZM8.33337 15.0003C8.16761 15.0003 8.00864 14.9345 7.89143 14.8173C7.77422 14.7001 7.70837 14.5411 7.70837 14.3753C7.70837 14.2096 7.77422 14.0506 7.89143 13.9334C8.00864 13.8162 8.16761 13.7503 8.33337 13.7503H11.6667C11.8325 13.7503 11.9914 13.8162 12.1086 13.9334C12.2259 14.0506 12.2917 14.2096 12.2917 14.3753C12.2917 14.5411 12.2259 14.7001 12.1086 14.8173C11.9914 14.9345 11.8325 15.0003 11.6667 15.0003H8.33337Z"
                                fill="#35374B" />
                        </svg>
                    </div>
                    <div class="tool-icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10 4.14062L10.9531 4.375C12.9375 4.85938 14.3906 6.67188 14.3906 8.6875V13.6562L14.75 14.0156L15.2344 14.5156H4.76562L5.25 14.0156L5.60938 13.6562V8.6875C5.60938 6.67188 7.04688 4.84375 9.04688 4.375L10 4.14062ZM10 1.25C9.28125 1.25 8.75 1.84375 8.75 2.57812V3.17187C6.26562 3.75 4.35938 6 4.35938 8.6875V13.1562L2.65625 14.9062V15.7812H17.3438V14.9062L15.6406 13.1562V8.6875C15.6406 6 13.7344 3.75 11.25 3.15625V2.59375C11.25 1.96875 10.9062 1.40625 10.3125 1.28125C10.2031 1.25 10.0938 1.25 10 1.25ZM11.7188 17.0312H8.28125C8.28125 18 9.03125 18.75 10 18.75C10.9688 18.75 11.7188 18 11.7188 17.0312Z"
                                fill="#35374B" />
                        </svg>
                    </div>
                    <el-popover class="box-item" trigger="click" placement="bottom-end" :show-arrow="false"
                        popper-class="user_popover">
                        <template #reference>
                            <div class="admin">
                                <div class="tool-icon">
                                    <!-- <img src="@/assets/image/avatar_default.png" alt=""> -->
                                    <img src="../assets/svg/user.svg" alt="">
                                </div>
                                <span class="admin_name">{{ userInfo.realName }}</span>
                            </div>
                        </template>
                        <template #default>
                            <div class="popover_wrapper">
                                <div class="log_out" @click="logout">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M8.33325 1C8.37703 1 8.42037 1.00862 8.46081 1.02537C8.50125 1.04213 8.538 1.06668 8.56895 1.09763C8.59991 1.12858 8.62446 1.16533 8.64121 1.20577C8.65796 1.24621 8.66658 1.28956 8.66658 1.33333V2C8.66658 2.04377 8.65796 2.08712 8.64121 2.12756C8.62446 2.168 8.59991 2.20475 8.56895 2.2357C8.538 2.26666 8.50125 2.29121 8.46081 2.30796C8.42037 2.32471 8.37703 2.33333 8.33325 2.33333H2.66659V13.6667H8.33325C8.37703 13.6667 8.42037 13.6753 8.46081 13.692C8.50125 13.7088 8.538 13.7333 8.56895 13.7643C8.59991 13.7952 8.62446 13.832 8.64121 13.8724C8.65796 13.9129 8.66658 13.9562 8.66658 14V14.6667C8.66658 14.7104 8.65796 14.7538 8.64121 14.7942C8.62446 14.8347 8.59991 14.8714 8.56895 14.9024C8.538 14.9333 8.50125 14.9579 8.46081 14.9746C8.42037 14.9914 8.37703 15 8.33325 15H2.66659C2.3245 15 1.99551 14.8685 1.74765 14.6328C1.49979 14.397 1.35202 14.075 1.33492 13.7333L1.33325 13.6667V2.33333C1.33325 1.99125 1.46473 1.66226 1.70049 1.4144C1.93626 1.16653 2.25827 1.01877 2.59992 1.00167L2.66659 1H8.33325ZM11.3736 4.431L14.2356 7.293C14.415 7.47247 14.5195 7.71346 14.5279 7.96711C14.5362 8.22076 14.4478 8.46811 14.2806 8.659L14.2356 8.707L11.3736 11.569C11.3111 11.6315 11.2263 11.6666 11.1379 11.6666C11.0495 11.6666 10.9648 11.6315 10.9023 11.569L10.4309 11.0977C10.3684 11.0352 10.3333 10.9504 10.3333 10.862C10.3333 10.7736 10.3684 10.6888 10.4309 10.6263L12.3899 8.66667H5.66658C5.62281 8.66667 5.57947 8.65805 5.53902 8.64129C5.49858 8.62454 5.46184 8.59999 5.43088 8.56904C5.39993 8.53808 5.37538 8.50134 5.35862 8.46089C5.34187 8.42045 5.33325 8.37711 5.33325 8.33333V7.66667C5.33325 7.62289 5.34187 7.57955 5.35862 7.53911C5.37538 7.49866 5.39993 7.46192 5.43088 7.43096C5.46184 7.40001 5.49858 7.37546 5.53902 7.35871C5.57947 7.34196 5.62281 7.33333 5.66658 7.33333H12.3899L10.4309 5.37367C10.3684 5.31116 10.3333 5.22639 10.3333 5.138C10.3333 5.04961 10.3684 4.96484 10.4309 4.90233L10.9023 4.431C10.9648 4.36851 11.0495 4.3334 11.1379 4.3334C11.2263 4.3334 11.3111 4.36851 11.3736 4.431Z"
                                            fill="#35374B" />
                                    </svg>
                                </div>
                                <div class="avatar_wrapper">
                                    <div class="avatar">
                                        <!-- <img src="@/assets/image/avatar_default.png" alt=""> -->
                                        <img src="../assets/svg/user.svg" alt="">
                                    </div>
                                    <div class="user_name">{{ userInfo.realName }}</div>
                                    <div class="position">
                                        <span>{{ userInfo.organizationName || '-' }}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="2" height="12" viewBox="0 0 2 12"
                                            fill="none">
                                            <path d="M1 1V11.5" stroke="#6A7077" stroke-linecap="round" />
                                        </svg>
                                        <span>{{ userInfo.roleName }}</span>
                                    </div>
                                </div>
                                <div class="popover_bottom">
                                    <div class="bottom_item" @click="jumpPage('WorkingHours')">
                                        <div class="svg_box">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                                                viewBox="0 0 32 32" fill="none">
                                                <path
                                                    d="M16 4C14.4241 4 12.8637 4.31039 11.4078 4.91345C9.95189 5.5165 8.62902 6.40042 7.51472 7.51472C6.40042 8.62902 5.5165 9.95189 4.91345 11.4078C4.31039 12.8637 4 14.4241 4 16C4 17.5759 4.31039 19.1363 4.91345 20.5922C5.5165 22.0481 6.40042 23.371 7.51472 24.4853C8.62902 25.5996 9.95189 26.4835 11.4078 27.0866C12.8637 27.6896 14.4241 28 16 28C19.1826 28 22.2348 26.7357 24.4853 24.4853C26.7357 22.2348 28 19.1826 28 16C28 12.8174 26.7357 9.76515 24.4853 7.51472C22.2348 5.26428 19.1826 4 16 4ZM22.004 17.324H15.632C15.5027 17.3248 15.3746 17.2999 15.255 17.2509C15.1354 17.2019 15.0267 17.1296 14.9351 17.0383C14.8436 16.947 14.7711 16.8384 14.7219 16.7189C14.6726 16.5994 14.6475 16.4713 14.648 16.342V9.97C14.648 9.70903 14.7517 9.45874 14.9362 9.27421C15.1207 9.08967 15.371 8.986 15.632 8.986C15.893 8.986 16.1433 9.08967 16.3278 9.27421C16.5123 9.45874 16.616 9.70903 16.616 9.97V15.356H22.004C22.265 15.356 22.5153 15.4597 22.6998 15.6442C22.8843 15.8287 22.988 16.079 22.988 16.34C22.988 16.601 22.8843 16.8513 22.6998 17.0358C22.5153 17.2203 22.265 17.324 22.004 17.324Z"
                                                    fill="#A1A6AA" />
                                            </svg>
                                        </div>
                                        <div>休息时间</div>
                                    </div>
                                    <div class="bottom_item" @click="jumpPage('TestRecord')">
                                        <div class="svg_box">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                                                viewBox="0 0 32 32" fill="none">
                                                <path
                                                    d="M19.8267 26.0603H20.8533H19.8267ZM29.48 25.1069H28H29.48ZM23.6667 19.7603C23.6659 20.0317 23.7548 20.2959 23.9194 20.5117C24.0841 20.7275 24.3154 20.883 24.5774 20.954C24.8394 21.025 25.1176 21.0076 25.3687 20.9044C25.6198 20.8012 25.8299 20.6181 25.9663 20.3834C26.1027 20.1487 26.1579 19.8755 26.1232 19.6063C26.0886 19.337 25.9661 19.0867 25.7747 18.8942C25.5833 18.7016 25.3338 18.5776 25.0647 18.5413C24.7957 18.5051 24.5222 18.5586 24.2867 18.6936C24.0988 18.8013 23.9425 18.9566 23.8337 19.1438C23.7249 19.3311 23.6672 19.5437 23.6667 19.7603ZM28.78 24.8269H27.1667H28.78ZM13.5333 23.3336H15.8667H13.5333Z"
                                                    fill="#A1A6AA" />
                                                <path
                                                    d="M21.9867 8.96669C21.8952 8.96903 21.8041 8.95248 21.7192 8.91807C21.6343 8.88366 21.5575 8.83213 21.4934 8.76669C21.3578 8.63018 21.2452 8.47258 21.1601 8.30003C21.0725 8.12612 21.0054 7.94268 20.9601 7.75336C20.9203 7.60082 20.8979 7.44427 20.8934 7.28669V4.00003H20.9467C21.0994 3.99919 21.2517 4.0171 21.4001 4.05336C21.5858 4.10955 21.7613 4.19507 21.9201 4.30669C22.1785 4.48022 22.4278 4.66714 22.6667 4.86669C22.9601 5.10669 23.3289 5.42225 23.7734 5.81336C24.2178 6.20447 24.6001 6.56447 24.9201 6.89336C25.1582 7.12759 25.3809 7.377 25.5867 7.64003C25.7116 7.7944 25.8066 7.97076 25.8667 8.16003C25.8995 8.28187 25.9174 8.40722 25.9201 8.53336V8.96003L21.9867 8.96669ZM30.2734 21.52C30.3331 21.6921 30.3689 21.8716 30.3801 22.0534C30.3848 22.1691 30.3633 22.2844 30.3171 22.3906C30.2709 22.4969 30.2013 22.5912 30.1134 22.6667L29.8734 22.92L29.6867 23.12C29.6297 23.1792 29.5672 23.2327 29.5001 23.28L27.2334 21.04L27.5934 20.72C27.7267 20.5956 27.8378 20.4978 27.9267 20.4267C28.0133 20.3392 28.1175 20.2714 28.2326 20.2277C28.3476 20.184 28.4706 20.1654 28.5934 20.1734C28.8073 20.1898 29.0158 20.2487 29.2067 20.3467C29.424 20.467 29.6181 20.625 29.7801 20.8134C29.9748 21.0206 30.1326 21.2596 30.2467 21.52H30.2734ZM20.8667 24C21.2229 24.0118 21.5719 23.8986 21.8534 23.68L16.6801 29.0667H9.34672C8.96035 29.0542 8.5819 28.9539 8.24005 28.7734C7.82389 28.5734 7.4397 28.3128 7.10005 28C6.75347 27.6802 6.46081 27.3065 6.23339 26.8934C6.00971 26.4988 5.8904 26.0536 5.88672 25.6V7.44669C5.89322 7.04273 5.97931 6.64402 6.14005 6.27336C6.29875 5.86975 6.52411 5.49566 6.80672 5.16669C7.09559 4.84139 7.43289 4.56256 7.80672 4.34003C8.16498 4.11758 8.57834 3.99981 9.00005 4.00003H19.2134V7.33336C19.2179 7.70329 19.2718 8.07097 19.3734 8.42669C19.4772 8.81143 19.6438 9.17636 19.8667 9.50669C20.0939 9.84046 20.3893 10.1222 20.7334 10.3334C21.1197 10.5639 21.5637 10.6795 22.0134 10.6667H25.9067V19.4934L22.2534 23.28C22.4243 23.0283 22.5234 22.7347 22.5399 22.4309C22.5564 22.1271 22.4898 21.8245 22.3472 21.5557C22.2045 21.2869 21.9913 21.0621 21.7305 20.9055C21.4696 20.7488 21.171 20.6663 20.8667 20.6667H10.8667C10.6476 20.6627 10.43 20.7045 10.2279 20.7894C10.0259 20.8744 9.84381 21.0006 9.69339 21.16C9.5379 21.3155 9.41529 21.5007 9.33283 21.7046C9.25037 21.9085 9.20975 22.1268 9.21339 22.3467C9.2116 22.5649 9.25336 22.7812 9.33623 22.9831C9.4191 23.1849 9.54142 23.3682 9.69601 23.5221C9.8506 23.6761 10.0344 23.7977 10.2365 23.8797C10.4387 23.9618 10.6552 24.0027 10.8734 24H20.8667ZM10.8667 14C10.6476 13.996 10.43 14.0378 10.2279 14.1227C10.0259 14.2077 9.84381 14.3339 9.69339 14.4934C9.5379 14.6489 9.41529 14.8341 9.33283 15.0379C9.25037 15.2418 9.20975 15.4602 9.21339 15.68C9.2116 15.8982 9.25336 16.1146 9.33623 16.3164C9.4191 16.5182 9.54142 16.7015 9.69601 16.8555C9.8506 17.0094 10.0344 17.131 10.2365 17.2131C10.4387 17.2951 10.6552 17.336 10.8734 17.3334H20.8734C21.0933 17.337 21.3116 17.2964 21.5155 17.2139C21.7193 17.1315 21.9045 17.0088 22.0601 16.8534C22.2195 16.7029 22.3457 16.5209 22.4307 16.3188C22.5156 16.1168 22.5574 15.8992 22.5534 15.68C22.5516 15.2339 22.3731 14.8066 22.057 14.4917C21.7409 14.1768 21.3129 14 20.8667 14H10.8667ZM20.9201 27.3334L21.2667 26.9867L21.9334 26.32L22.8134 25.4267L23.7734 24.4534C24.5378 23.7067 25.3912 22.8623 26.3334 21.92L28.5734 24.16L25.0267 27.7067L24.1467 28.5867L23.5201 29.2534L23.2401 29.5467L22.9467 29.7734C22.8463 29.8495 22.7392 29.9164 22.6267 29.9734C22.466 30.0488 22.3013 30.1156 22.1334 30.1734L21.4667 30.4L20.8001 30.5867L20.3334 30.6667C20.1201 30.7022 19.9778 30.6756 19.9067 30.5867C19.8676 30.5187 19.8427 30.4434 19.8336 30.3655C19.8244 30.2876 19.8312 30.2086 19.8534 30.1334C19.8534 30.0267 19.8889 29.8667 19.9601 29.6534C20.0312 29.44 20.0934 29.2178 20.1467 28.9867L20.3467 28.36C20.3867 28.2236 20.4357 28.09 20.4934 27.96C20.5981 27.7319 20.7425 27.5242 20.9201 27.3467V27.3334Z"
                                                    fill="#A1A6AA" />
                                            </svg>
                                        </div>
                                        <div>测试记录</div>
                                    </div>
                                    <div class="bottom_item" @click="openDialog('editPassword')">
                                        <div class="svg_box">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                                                viewBox="0 0 32 32" fill="none">
                                                <path
                                                    d="M24.7837 12.5338V9.83792C24.7837 5.51016 21.0876 2 16.5261 2C11.9647 2 8.26861 5.51013 8.26861 9.83792V12.4889C6.25488 12.627 4.66675 14.2216 4.66675 16.1685V26.3119C4.66675 28.3482 6.4062 30 8.55257 30H24.1143C26.2606 30 28.0001 28.3482 28.0001 26.3119V16.1685C28.0001 14.3476 26.6109 12.835 24.7837 12.5338ZM18.249 21.9859V25.4017H15.3345V22.0408C14.3585 21.5588 13.6922 20.5902 13.6922 19.4738C13.6922 17.8765 15.0553 16.5819 16.7387 16.5819C18.422 16.5819 19.7852 17.8765 19.7852 19.4738C19.7852 20.5493 19.1669 21.4877 18.249 21.9859ZM22.1652 12.479H10.8582V10.3182C10.8582 7.35492 13.3886 4.95084 16.5125 4.95084C19.6332 4.95084 22.1652 7.35492 22.1652 10.3182V12.479H22.1652Z"
                                                    fill="#A1A6AA" />
                                            </svg>
                                        </div>
                                        <div>修改密码</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-popover>
                </div>
            </div>
        </header>

        <!-- 主内容区（左侧侧边栏+右侧内容） -->
        <div class="main-content">
            <router-view /> <!-- 渲染当前路由对应的页面 -->
        </div>
    </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import router from '@/router' // 导入路由实例
import { ref, onMounted, onUnmounted, computed, watch, reactive } from 'vue';
import { useUserStore } from '@/stores/user'
import eventBus from '@/utils/eventBus'
import MobileNav from '@/components/MobileNav.vue'

const userStore = useUserStore()
const route = useRoute()
// 当前激活的路由
const currentRoute = ref(route.path.substring(1))
// 移动端菜单状态
const isMobileMenuOpen = ref(false)

// 导航方法
const navigate = (path) => {
    currentRoute.value = path;
    // 实际项目中可以使用路由跳转
    router.push(`/${path}`);
};
const userInfo = reactive(userStore.userInfo)
onMounted(() => {

})
const jumpHome = () => {
    router.push('/')
    currentRoute.value = 'dashboard';
}
// 全屏状态
let isFullscreen = ref(false)
// 检查当前是否处于全屏状态
const checkFullscreenStatus = () => {
    isFullscreen.value = !!document.fullscreenElement
}
const fullscreenTarget = ref(null)
// 切换全屏状态
const toggleFullscreen = () => {
    // 如果当前是全屏状态，则退出
    if (isFullscreen.value) {
        if (document.exitFullscreen) {
            document.exitFullscreen().catch(err => {
                console.error('退出全屏失败:', err)
            })
        }
        return
    }

    // 进入全屏
    const target = fullscreenTarget.value || document.documentElement
    if (target.requestFullscreen) {
        target.requestFullscreen().catch(err => {
            console.error('进入全屏失败:', err)
            alert('全屏操作被浏览器阻止，请允许全屏权限')
        })
    }
}

// 监听全屏状态变化事件
const handleFullscreenChange = () => {
    checkFullscreenStatus()
}

// 组件挂载时初始化
onMounted(() => {
    checkFullscreenStatus()
    document.addEventListener('fullscreenchange', handleFullscreenChange)

    // 监听ESC键退出全屏
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isFullscreen.value) {
            checkFullscreenStatus()
        }
    })
})

// 组件卸载时清理
onUnmounted(() => {
    document.removeEventListener('fullscreenchange', handleFullscreenChange)
})

// 打开弹窗
const openDialog = async (flag) => {
    await router.push('/profile')
    currentRoute.value = 'profile';
    eventBus.emit('open-dialog', flag)
}
// 点击跳转
const jumpPage = (url) => {
    router.push({
        name: url
    })
}

// 全屏状态变化时的处理
watch(isFullscreen, (newVal) => {
    if (newVal) {
        console.log('进入全屏模式')
        // 可以在这里添加全屏模式下的初始化操作
    } else {
        console.log('退出全屏模式')
        // 可以在这里添加退出全屏后的清理操作
    }
})
// 退出登录
const logout = () => {
    userStore.logout()
}

// 切换移动端菜单
const toggleMobileMenu = () => {
    isMobileMenuOpen.value = !isMobileMenuOpen.value
}
</script>

<style>
.user_popover {
    width: 320px !important;
    padding: 0 !important;
    box-shadow: -6px 7px 30.7px 0 rgba(0, 0, 0, 0.03) !important;
    border-radius: 16px !important;
    border: none !important;
    background: #FFF;
}
</style>
<style scoped lang="scss">
/* 布局样式 */
.layout-container {
    min-height: 100vh;
    background-color: #f5f7fa;
    color: $primary-color;
}

// 移动端汉堡菜单按钮
.mobile-menu-btn {
    @include hide-on-desktop;
    @include touch-target(40PX);
    border-radius: 8PX;
    background: #f4f4f4;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #1A1A1A;
    margin-right: $spacing-md;
    
    @include mobile {
        display: inline-flex;
    }
    
    &:active {
        background: #e0e0e0;
        transform: scale(0.95);
    }
}

// 桌面端显示元素
.desktop-only {
    @include mobile {
        display: none !important;
    }
}

// 顶部导航栏
.main-header {
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    position: sticky;
    top: 0;
    z-index: $z-index-sticky;
    @include safe-area-inset('top');

    .header-container {
        @include flex-center;
        justify-content: space-between;
        margin: 0 auto;
        padding: 0 32px;
        height: 84px;
        
        @include mobile {
            padding: 0 $spacing-md;
            height: 60PX;
        }
        
        @include tablet {
            padding: 0 $spacing-lg;
            height: 70PX;
        }

        .logo {
            color: #1A1A1A;
            font-family: YouSheBiaoTiYuan;
            font-size: 24px;
            font-weight: 400;
            line-height: 16px;
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
                width: 51px;
                height: 44px;
                margin-right: 10px;
                
                @include mobile {
                    width: 36PX;
                    height: 32PX;
                    margin-right: 8PX;
                }
            }
            
            span {
                @include mobile {
                    font-size: $font-size-medium-mobile;
                }
            }
        }

        .nav-menu {
            width: auto;
            border-bottom: none;
            gap: 12px;
            /* 添加菜单项之间的间隙 */

            .el-menu-item {
                width: 192px;
                height: 54px !important;
                line-height: 64px;
                border-bottom: none;
                border-radius: 7px;
                color: #6A7077;
                font-size: 24px;
                font-weight: 400;
                margin-right: 0;
                /* 移除默认margin，使用gap控制间距 */

                span {
                    margin-left: 8px;
                }

                svg {
                    width: 30px;
                    height: 30px;
                }

                &:hover {
                    background-color: transparent;
                    color: #6A7077 !important;
                    /* hover时保持字体颜色不变 */
                }
            }

            .active-bg {
                background: #F4F6F8 !important;
                color: #6A7077 !important;
                font-size: 24px;
                font-weight: 500;
            }
        }

        .header-tools {
            @include flex-center;
            gap: 16px;

            .tool-icon {
                width: 40px;
                height: 40px;
                background-color: #F4F4F4;
                border-radius: 50%;
                @include flex-center;
                cursor: pointer;
                position: relative;

                svg {
                    width: 20px;
                    height: 20px;
                }

                img {
                    width: 40px;
                    height: 40px;
                    // width: 32px;
                    // height: 32px;
                    // position: absolute;
                    // top: 1px;
                    // left: 50%;
                    // margin-left: -16px;
                }

                &:hover {
                    background-color: #f1efef;
                }
            }

            .admin {
                display: flex;
                align-items: center;
                cursor: pointer;

                .admin_name {
                    color: #1A1A1A;
                    margin-left: 12px;
                    font-size: 16px;
                }
            }
        }
    }
}

.el-popper {
    height: 313px;
}

.popover_wrapper {
    padding: 0 16px;

    .log_out {
        width: 32px;
        height: 32px;
        background-color: #F4F6F8;
        border-radius: 50%;
        @include flex-center;
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;

        svg {
            width: 16px;
            height: 16px;
        }
    }

    .avatar_wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 32px;

        .avatar {
            width: 68px;
            height: 68px;
            background-color: #eee;
            border-radius: 50%;
            position: relative;
            @include flex-center;

            img {
                width: 68px;
                height: 68px;
                // width: 54.4px;
                // height: 54.4px;
                // position: absolute;
                // top: 1.7px;
                // left: 50%;
                // margin-left: -27.2px;
            }
        }

        .user_name {
            margin: 10px 0 8px;
            color: #1A1A1A;
            font-size: 20px;
            font-weight: 500;
            line-height: 24px;
        }

        .position {
            display: flex;
            align-items: center;
            color: #6A7077;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;

            svg {
                margin: 0 8px;
            }
        }
    }

    .popover_bottom {
        margin: 24px 0;
        display: flex;
        justify-content: space-evenly;

        .bottom_item {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #A1A6AA;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            cursor: pointer;

            .svg_box {
                width: 56px;
                height: 56px;
                border: 1px solid #F4F4F4;
                border-radius: 50%;
                margin-bottom: 11px;
                @include flex-center;

                svg {
                    width: 32px;
                    height: 32px;
                }
            }
        }
    }
}

.main-content {
    display: flex;
    flex: 1;
    overflow: hidden;
    padding: 32px;
    padding-bottom: 50px;
    height: calc(100vh - 86px);
    
    @include mobile {
        padding: $spacing-md;
        padding-bottom: $spacing-lg;
        height: calc(100vh - 60PX);
        @include safe-area-inset('bottom');
    }
    
    @include tablet {
        padding: $spacing-lg;
        height: calc(100vh - 70PX);
    }

    .sidebar {
        width: 200px;
        background: #001529;
        color: #fff;

        .sidebar-menu {
            height: 100%;
            border-right: none;
        }
        
        @include mobile {
            display: none;
        }
    }

    .content-wrapper {
        flex: 1;
        padding: 20px;
        overflow-y: auto;
        background: #f5f7fa;
        @include smooth-scroll;
        
        @include mobile {
            padding: 0;
        }
    }
}
</style>